import React from 'react';
import { Form } from 'antd';
import { Button } from '../../components/Button';
import { Select } from '../../components/Select';
import { ArrowIcon } from '../../icons/ArrowIcon';
import { Flex } from '../../components/Flex';
import { Label, Paragraph } from '../../components/Text';
import { toLower } from 'lodash';


const LoginForm = ({ onSubmit, onCancel, switchOrg, orgs }) => {
    let formContent = <>
        <Flex justify="space-between">
            <Button type="submit">
                Sign In
                <ArrowIcon key="arrow-icon" size={20} />
            </Button>
        </Flex>
    </>;

    if (switchOrg) formContent = <>
        <Form.Item
            name="org"
            rules={[{ required: true, message: 'Please select an organization' }]}
        >
            <Select
                bordered
                allowClear
                showSearch
                size={"large"}
                filterOption={(input, option) => toLower(option.title).indexOf(toLower(input)) >= 0}
            >
                {orgs.map(org => (
                    <Select.Option key={org.alias} title={org.name}>
                        <Flex align="center" justify="space-between" height="40px">
                            <Paragraph nowrap maxWidth="210px" title={org.name}>{org.name}</Paragraph>{org.defaultOrg ? <Label bold>[default]</Label> : null}
                        </Flex>
                    </Select.Option>
                ))}
            </Select>
        </Form.Item>
        <Flex justify="space-between">
            <Button type="submit">
                Switch
            </Button>
            <Button link onClick={onCancel}>
                Cancel
            </Button>
        </Flex>
    </>
    return(
        <Form
            name="login_form"
            className="login-form"
            onFinish={onSubmit}
            initialValues={{}}
        >
            {formContent}
        </Form>
    );
};

export { LoginForm };